import { MiniMapBackgroundProps } from "./types"; // Assuming you export ViewBox from types

export const MiniMapBackground = ({
  width,
  height,
  imageUrl,
  onImageLoad,
  onImageError,
}: MiniMapBackgroundProps) => {
  return (
    <g id="minimap-background-layer">
      {/* Render the image directly */}
      <image
        href={imageUrl}
        x="0"
        y="0"
        width={width}
        height={height}
        preserveAspectRatio="xMidYMid meet"
        crossOrigin="anonymous"
        style={{ display: "block" }} /* Removes bottom spacing gap */
        onLoad={onImageLoad}
        onError={onImageError}
      />
      {/* The Dark Overlay */}
      <rect
        x="0"
        y="0"
        width={width}
        height={height}
        fill="rgba(0,0,0,0.2)"
        pointerEvents="none" /* Ensures clicks pass through to elements below if needed */
      />
    </g>
  );
};
